import React from 'react'
import './AllProjects.scss'
import PropTypes from 'prop-types'
import { AllProjectsCardItem } from '@components/custom'

const AllProjects = props => {
  const { allProjects, count, userId, deleteProject, totalProjectsText, onSelectFavorite } = props

  const navigateToPreview = projectId => {
    props.history.push(`/preview/${projectId}`)
  }

  return (
    <div data-testid="all-projects">
      {
        (count > 0) ? (
          <div data-testid="all-projects-data">
            <div className="all-projects-menu">
              <div className="all-projects-title">{count} Projects {totalProjectsText}</div>
              {/* <div className="all-projects-sort">
                  <SortProjectsList sortBy={sortBy} />
                  <div className="appsIcon">
                    <img src="/images/apps.svg" />
                  </div>
                </div> */}
            </div>
            <div>
              {allProjects && allProjects.map((project, index) =>
                <AllProjectsCardItem key={index} projectData={project} onClick={() => navigateToPreview(project.id)} userId={userId} deleteProject={deleteProject} onSelectFavorite={onSelectFavorite} />
              )}
            </div>
          </div>
        ) : (
            <div data-testid="no-projects-data" className="no-projects">No Projects Found</div>
          )
      }
    </div>
  )
}

AllProjects.propTypes = {
  allProjects: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  count: PropTypes.number,
  userId: PropTypes.string,
  deleteProject: PropTypes.func,
  totalProjectsText: PropTypes.string,
  onSelectFavorite: PropTypes.func
}

export default AllProjects
